export default "__VITE_ASSET__8vVCvI_W__"